module.exports = __webpack_public_path__ + "static/aws_security-37906c6b892a58c6ff5879f78962174f.png";